const defaultState={//创建一个默认state
    searchData: {
        page: 1,
        size: 10
    }
};

export default (state=defaultState,action)=>{
    if (action.type==='saveSearchData'){
        const newState=JSON.parse(JSON.stringify(state));//对原有数据进行深拷贝
        newState.searchData = action.value;
        return newState;
    }
    return state;
}
